const firebaseConfig = {
    apiKey: "AIzaSyBtMq581803m7DN3RzV7UR6Z4BMavG94xQ",
    authDomain: "capture-moments-3a53d.firebaseapp.com",
    projectId: "capture-moments-3a53d",
    storageBucket: "capture-moments-3a53d.appspot.com",
    messagingSenderId: "588776915665",
    appId: "1:588776915665:web:64b3404c1db4948efc3bf0"
  };

  export default firebaseConfig